import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Avatar from './Avatar';

const Header = ({ user, userType = 'student', showMenu = true }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const getNavigationItems = () => {
    if (userType === 'student') {
      return [
        { label: 'Dashboard', href: '/student/dashboard' },
        { label: 'My Profile', href: '/student/profile' },
        { label: 'Messages', href: '/messages' },
      ];
    } else if (userType === 'advisor') {
      return [
        { label: 'Dashboard', href: '/dashboard' },
        { label: 'My Posts', href: '/hiring' },
        { label: 'Messages', href: '/messages' },
      ];
    }
    return [];
  };

  const navigationItems = getNavigationItems();

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <a href={userType === 'student' ? '/student' : '/dashboard'} className="flex items-center">
              <span className="text-xl font-bold text-blue-600">FindBob</span>
              {userType === 'student' && (
                <span className="ml-2 text-sm text-gray-600">Student</span>
              )}
            </a>
          </div>

          {/* Desktop Navigation */}
          {showMenu && (
            <nav className="hidden md:flex items-center space-x-6">
              {navigationItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          )}

          {/* User Menu */}
          <div className="flex items-center gap-4">
            {user && (
              <div className="flex items-center gap-3">
                <span className="hidden sm:block text-sm font-medium text-gray-700">
                  {user.name}
                </span>
                <Avatar src={user.avatar} name={user.name} size="sm" />
              </div>
            )}

            {/* Mobile menu button */}
            {showMenu && (
              <button
                type="button"
                className="md:hidden inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-blue-600 hover:bg-gray-100"
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              >
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  {isMobileMenuOpen ? (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  ) : (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  )}
                </svg>
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {showMenu && isMobileMenuOpen && (
        <div className="md:hidden border-t border-gray-200">
          <nav className="px-4 py-3 space-y-1">
            {navigationItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

Header.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    avatar: PropTypes.string,
  }),
  userType: PropTypes.oneOf(['student', 'advisor', 'public']),
  showMenu: PropTypes.bool,
};

export default Header;


